<template>
  <div v-if="appStore.state.apiError">
    <error-view />
  </div>
  <div
    v-else-if="
      (appStore.state.initialLoading && !route.meta.allowUnauthorized) ||
      wizardFlowsStore.state.loading
    "
  >
    <loading-view />
  </div>
  <template
    v-else-if="
      wizardFlowsStore.state.initiateFlow && !route.meta.wizardExcluded
    "
  >
    <top-navbar
      v-if="wizardFlowsStore.state.initiateFlow === 'MatchingQuizFlow'"
      class="fixed top-0 w-full z-30"
    />
    <contact-button
      v-if="wizardFlowsStore.state.initiateFlow === 'MatchingQuizFlow'"
    />
    <wizard-flow-overlay />
  </template>
  <div v-else class="bg-white">
    <main
      class="h-full"
      :class="{ 'scrolling-up': appStore.state.showBackToTop }"
    >
      <router-view></router-view>
    </main>
  </div>
  <iu-modal-feedback v-if="appStore.state.showUserFeedback" />

  <!-- TODO: Fix Tailwind for autodetect `bg-${color}` classes -->
  <span
    class="hidden bg-orange border-orange bg-orange-light hover:bg-orange-light border-r-orange border-r-orange-light border-orange-light bg-blue border-blue hover:bg-blue-light bg-blue-light border-r-blue-light border-blue-light border-r-blue-lighter bg-green border-green hover:bg-green-light lg:bg-green-light border-green-light bg-yellow border-yellow hover:bg-yellow-light border-r-yellow-light border-yellow-light bg-pink border-pink hover:bg-pink-light border-pink-light bg-pink-light bg-red border-red bg-red-light hover:bg-red-light border-red-light bg-cta-light border-cta-light bg-cta-light-light hover:bg-cta-light-light border-cta-light-light bg-gray-50 border-gray-50 hover:bg-gray-lighter border-gray-lighter h-[150px] h-[300px] mb-[46px] mb-[94px] mb-[76px] top-[210px] top-[175px]"
  ></span>
</template>

<script setup lang="ts">
import appStore from '@/stores/app.store'
import LoadingView from '@/pages/LoadingView.vue'
import IuModalFeedback from '@/components/modal/IuModalFeedback.vue'
import ErrorView from '@/pages/ErrorView.vue'
import determineScrollDirection from '@/functions/determineScrollDirection'
import { useRoute, useRouter } from 'vue-router'
import apiService from '@/services/api.service'
import { UsercentricsService as usercentricsService } from '@/services/usercentrics'
import { onMounted } from 'vue'
import wizardFlowsStore from '@/modules/wizard/stores/wizard-flows.store'
import WizardFlowOverlay from '@/modules/wizard/components/wizard/WizardFlowOverlay.vue'
import TopNavbar from '@/components/layout/TopNavbar.vue'
import ContactButton from '@/units/ds/components/ContactButton.vue'

const router = useRouter()
const route = useRoute()

router.afterEach((to) => {
  if (to.name === 'ds.home' || to.meta?.wizardExcluded) return
  if (wizardFlowsStore.state.initiateFlow) {
    wizardFlowsStore.clearInitiateFlow()
  }
})

onMounted(() => {
  initDocumentTitle()
  registerEventListeners()
  usercentricsService.activate()

  setTimeout(() => {
    console.log('Check for t parameter...', route.query.t)
    if (route?.query?.t) {
      console.log(`Parameter 't' available: ${route.query.t}`)
      apiService.general.sendTrackingId(route.query.t as string).then(() => {
        console.log(`Parameter 't' send to backend`)
      })
    }

    const currentQuery = { ...route.query }
    Object.keys(currentQuery).forEach((key) => {
      if (key.startsWith('utm') || key === 't') {
        delete currentQuery[key]
      }
    })
    if (JSON.stringify(currentQuery) !== JSON.stringify(route.query)) {
      router.replace({ path: route.path, query: currentQuery })
    }
  }, 300)
})

const initDocumentTitle = () => {
  document.title = appStore.state.isB2b
    ? 'IU Unternehmensportal'
    : window?.location?.href?.includes('lebenslauf-generator')
      ? 'Lebenslaufgenerator'
      : 'IU Bewerbungsportal'
}

const registerEventListeners = () => {
  window.addEventListener('scroll', determineScrollDirection)
  window.addEventListener('initialLoadingCompleted', () => {
    if (appStore.state.isB2b) {
      return
    }

    wizardFlowsStore.fetchWizardFlows()
  })
}
</script>
